import { useEffect, useState } from 'react';
import { fetchCountryCode } from 'geo_util';
import { captureMessage } from 'error_tracker';

const useCountryFetch = () => {
	const [countryFetched, setCountryFetched] = useState(false);
	// autoFetchCountryCode
	useEffect(() => {
		if (countryFetched) return;
		fetchCountryCode()
			.then(country_code => {
				setCountryFetched(country_code);
			})
			.catch(error => {
				captureMessage(`Error on fetchCountryCode: ${error}`);
			});
	}, [countryFetched]);

	return countryFetched;
};

export default useCountryFetch;
